export const StatusKeysToDisplay: string[] = [
  'new',
  'accepted',
  'production',
  'shipped',
  'cancelled',
  'rejected'
];
